
import React from 'react';
import { PaperclipIcon } from 'lucide-react';

// This function returns a React element
// Since it's meant to be used in a .tsx file but is defined in a .ts file,
// we need to properly type it
export const renderFilePreview = (file: File): React.ReactElement => {
  const isImage = file.type.startsWith('image/');
  
  if (isImage) {
    return React.createElement('div', 
      { 
        className: "relative w-24 h-24 bg-knightblack/60 rounded-md overflow-hidden" 
      },
      React.createElement('img', {
        src: URL.createObjectURL(file),
        alt: file.name,
        className: "w-full h-full object-cover"
      })
    );
  }
  
  return React.createElement('div',
    {
      className: "relative flex items-center p-2 bg-knightblack/60 rounded-md"
    },
    [
      React.createElement(PaperclipIcon, {
        key: 'icon',
        className: "mr-2 h-4 w-4"
      }),
      React.createElement('span', {
        key: 'filename',
        className: "text-xs truncate max-w-[100px]"
      }, file.name)
    ]
  );
};
